import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router";
import { useSnackbar } from "notistack";
import { Box, Typography } from "@mui/material";
import { backendGet } from "@accredo/fe-shared/services/dataService.js";
import { getEuro, getDatumZeit } from "@accredo/fe-shared/services/formatService.js";
import Spinner from "@accredo/fe-shared/components/Spinner.jsx";
import BookingExportPaymentsTable from "components/tables/BookingExportPaymentsTable.jsx";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";

const BookingExportShowPage = () => {
  const { setBreadcrumbs } = useBreadcrumb();
  const { id } = useParams();
  const [bookingExport, setBookingExport] = useState(null);
  const [loading, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  const fetchBookingExport = useCallback(async () => {
    await backendGet(`data/bookingexports/${id}`, {
      label: "Buchungsexport",
      enqueueSnackbar,
      setIsLoading: setLoading,
      setResult: (res) => setBookingExport(res.data),
      options: {
        params: { include: ["payments", "created_by", "finished_by"] },
      },
    });
  }, [id, enqueueSnackbar]);

  useEffect(() => {
    fetchBookingExport();
  }, [fetchBookingExport]);

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Buchungsverwaltung", path: "/admin/buchungen" },
      { name: "Buchungsexporte", path: "/admin/buchungen/exports" },
      {
        name: bookingExport?.export_identifier || "",
        path: `/admin/buchungen/exports/${id}`,
      },
    ]);
  }, [setBreadcrumbs, bookingExport?.export_identifier, id]);

  const payments = bookingExport?.payments || [];

  if (loading) return <Spinner />;

  return (
    <>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Exportdetails: {bookingExport?.export_identifier}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Details und Zahlungen des Buchungs-Exports
        </Typography>
      </Box>

      <Box
        sx={{
          mb: 4,
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          columnGap: 2,
          rowGap: 1,
        }}
      >
        <Typography variant="body2" fontWeight="bold">
          Status:
        </Typography>
        <Typography variant="body2">{bookingExport?.status}</Typography>

        <Typography variant="body2" fontWeight="bold">
          Summe:
        </Typography>
        <Typography variant="body2">{getEuro(bookingExport?.summe)}</Typography>

        <Typography variant="body2" fontWeight="bold">
          Erstellt von:
        </Typography>
        <Typography variant="body2">
          {bookingExport?.created_by?.full_name || "-"}
        </Typography>

        <Typography variant="body2" fontWeight="bold">
          Erstellt am:
        </Typography>
        <Typography variant="body2">
          {getDatumZeit(bookingExport?.created_at)}
        </Typography>

        <Typography variant="body2" fontWeight="bold">
          Abgeschlossen am:
        </Typography>
        <Typography variant="body2">
          {getDatumZeit(bookingExport?.finished_at)}
        </Typography>
      </Box>

      <Typography variant="h6" gutterBottom>
        Zahlungen in diesem Export
      </Typography>

      <BookingExportPaymentsTable payments={payments} />
    </>
  );
};

export default BookingExportShowPage;
